
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, CardModule, LinkModule, MenuModule, NavigationStoreModule, SosAccountStoreModule, SosCoreModule, SystemIconModule, TagsModule } from '@serviceos-ng/core';
import { AccountMenuComponent } from './account-menu/account-menu.component';
import {  RouterModule } from '@angular/router';
import { AccountDetailsModule } from '../account-details/account-details.module';


@NgModule({
  declarations: [
    AccountMenuComponent
  ],
  imports: [
    CommonModule,
    SosCoreModule,
    NavigationStoreModule,
    SosAccountStoreModule,
    AccountDetailsModule,
    SystemIconModule,
    MenuModule,
    CardModule,
    TagsModule,
    LinkModule,
    ButtonModule,
    RouterModule
  ], 
  exports: [
    AccountMenuComponent
  ]
})
export class MenusModule { }
